<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary" @click="backParent"><i class="fa fa-angle-left" aria-hidden="true"></i> Sale Order</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item active">
                  <span v-if="order.id === null">New</span>
                  <span v-else>
                    {{ order.order_no }}
                  </span>
                </li>
              </ol>
              <button type="button" @click="updateSales" class="btn btn-sm btn-soft-primary pull-left" v-show="order.order_no !== null" :disabled="order.lock"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createSales" class="btn btn-sm btn-soft-primary pull-left" v-show="order.order_no == null"><i class="fa fa-save" aria-hidden="true"></i> Create</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-list">
            <div class="card-header">
              <h5 v-if="order.order_no === null">New</h5>
              <h5 v-else>
                {{ order.order_no }}
                <span class="badge badge-success" v-if="order.status === 'open'">{{ order.status }}</span>
                <span class="badge badge-primary" v-else-if="order.status === 'approved'">{{ order.status }}</span>
                <span class="badge badge-warning" v-else>{{ order.status }}</span>
              </h5>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a.message"></li>
                </ul>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Customer <span v-if="order.customer_no">- {{ order.customer_no }}</span></dt>
                    <dd class="col-md-8">
                      <button type="button" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-soft-primary mr-1" :disabled="order.lock">+ New</button>
                      <button type="button" data-toggle="modal" data-target="#modalCustomerGrid" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-soft-primary" @click="getCustomerList" :disabled="order.lock">List</button>
                    </dd>

                    <dt class="col-md-4">Name</dt>
                    <dd class="col-md-8">{{ order.customer.name }}</dd>

                    <dt class="col-md-4">Phone</dt>
                    <dd class="col-md-8">{{ order.customer.phone }}</dd>

                    <dt class="col-md-4">Address</dt>
                    <dd class="col-md-8">{{ order.customer.address }}</dd>
                  </dl>
                  <dl class="row dl-custom">
                    <dt class="col-md-4">SP No.</dt>
                    <dd class="col-md-8">
                      <span v-if="order.lock">{{ order.project_name }}</span>
                      <input v-else type="text" class="form-control form-control-lite" v-model="order.project_name" @blur="getSpNo"/>
                      <span style="color: red" v-if="error.project_name !== ''">{{ error.project_name }}</span>
                    </dd>

                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">
                      <span v-if="order.lock">{{ order.order_date | dateFormat('DD/MM/YYYY') }}</span>
                      <datetime v-else v-model="order.order_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="order.lock"></datetime>
                    </dd>
                    <dt class="col-md-4">Term. Tempo</dt>
                    <dd class="col-md-8">
                      <select v-model="order.term_due_id" class="form-control form-control-lite" :disabled="order.lock">
                        <option v-for="t in termDueList" :key="t.id" :value="t.id">{{ t.name }}</option>
                      </select>
                    </dd>
                    <dt class="col-md-4">Company</dt>
                    <dd class="col-md-8">
                      <select v-model="order.company_no" class="form-control form-control-lite" @change="checkTax" :disabled="order.lock || order.order_no !== null">
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </dd>
                    <dt class="col-md-4">Tax</dt>
                    <dd class="col-md-8">
                      <select v-model="order.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="order.lock">
                        <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                      </select>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card" v-for="(d, index) in order.details" :key="index">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <span class="text-primary font-12">{{ d.product_no }}</span>
                  <p class="text-primary font-18">{{ d.description }}</p>
                  <p><b>{{ d.total | currency }}</b></p>
                </div>
                <div class="col-6">
                  <div>
                    <button type="button" class="btn btn-sm btn-soft-primary" @click="decreaseDetail(index)" :disabled="order.lock">-</button>
                    <input type="text" class="input-qty" v-model="d.qty" @keyup="calcRowPrice(index)" :disabled="order.lock"/>
                    <button type="button" class="btn btn-sm btn-soft-primary" @click="increaseDetail(index)" :disabled="order.lock">+</button>
                    <select v-model="d.uom_id" class="form-control" @change="calcRowPrice(index)" :disabled="order.lock">
                      <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                    </select>
                    <input type="text" v-model="d.price" v-money="money" class="form-control form-right" @keyup="calcRowPrice(index)" :disabled="order.lock" placeholder="price"/>
                    <input type="text" v-model="d.discount_percentage" class="form-control form-right" @keyup="calcRowPrice(index)" :disabled="order.lock" placeholder="discount"/>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <!-- <button type="button" class="btn btn-success btn-sm btn-block" @click="calcRowPrice(index)">Sync</button> -->
                  <button type="button" class="btn btn-danger btn-sm btn-block" @click="removeDetail(index)" :disabled="order.lock"><i class="fa fa-trash"></i> Remove</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="button" class="btn btn-sm btn-block btn-hard-primary" data-toggle="modal" data-target="#modalGetProductGrid" data-backdrop="static" data-keyboard="false" v-if="order.lock === false" :disabled="order.lock">
            <i class="fa fa-plus"></i> Add Product
          </button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <dl class="row">
                <div class="col-12">
                  <h5>Summary</h5>
                </div>
                <dt class="col-6">Subtotal</dt>
                <dd class="col-6 text-right">{{ order.subtotal | currency }}</dd>
                <dt class="col-6">Discount</dt>
                <dd class="col-6 text-right">{{ order.discount | currency }}</dd>
                <dt class="col-6">Tax</dt>
                <dd class="col-6 text-right">{{ order.tax | currency }}</dd>
                <dt class="col-6">Total</dt>
                <dd class="col-6 text-right">{{ order.total | currency }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- <SalesDetailModal :idDetail="idDetail" :sales="order" @selectProduct="selectProduct" :amountDue="getTotal"/> -->
      <SalesProductModal @selectProduct="selectProduct" :sales="order" :status="status" :date="order.order_date"/>
      <CustomerFormModal @createCustomer="createCustomer" />
      <CustomerGridModal @selectCustomerList="selectCustomerList" />
      <SaleOrderAttachmentModal :order="order"/>
      <SaleOrderDealFormModal :sales="dataSales" @processSales="processSales"/>
      <SaleModal />
      <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
      <SalesProductGridModal @selectProduct="selectProduct"/>
      <!-- <pre>{{ order.details }}</pre> -->
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in order.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import SalesProductModal from '@/components/sales/SalesProductModal.vue'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import CustomerGridModal from '@/components/customer/CustomerGridModal.vue'
import SaleOrderAttachmentModal from '@/components/sales/SaleOrderAttachmentModal.vue'
import SaleOrderDealFormModal from '@/components/sales/SaleOrderDealFormModal.vue'
import SaleModal from '@/components/sales/SaleModal.vue'
import { saleOrderUrl, getHeader, productUrl, salesUrl, customerUrl, lockUrl, sale2Url } from '../../config'
import Loading from 'vue-loading-overlay'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import SalesProductGridModal from '@/components/sales/SalesProductGridModal.vue'

export default {
  name: 'SaleSalesmanOrdeForm',
  props: ['order'],
  components: {
    SalesProductModal,
    CustomerFormModal,
    CustomerGridModal,
    SaleOrderAttachmentModal,
    SaleOrderDealFormModal,
    SaleModal,
    Loading,
    SalesRequestModal,
    SalesProductGridModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.onBarcodeScanned)
    // this.getType()
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      alert: [],
      card1: 'col-md-12',
      card2: null,
      searchQueryOrder: '',
      status: 'order',
      error: {
        project_name: ''
      },
      dataSales: {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        type: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        branch_no: null,
        warehouse_no: null,
        branch: null,
        subtotal: null,
        tax_id: null,
        taxes: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        salesman_id: null,
        salesman: null,
        status: null,
        price_id: null,
        price_list: null,
        overdue: '',
        order_no: null,
        company_no: null,
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product_sku: null,
          product: null,
          products: {
            canBarcode: null
          },
          description: null,
          barcode: null,
          qty: null,
          qty_done: null,
          serial_number: null,
          sec_serial_number: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          queue: null,
          warehouse_no: null,
          uomType: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: '0',
            active: false,
            cost: '0',
            price: '0'
          }],
          cost: '0',
          cost_id: null,
          margin: '0',
          margin_percentage: '0',
          internal_code: null
        }]
      },
      isTax: false,
      termCondition: null,
      file: null,
      loading: false,
      uploading: true,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      salesTypeList: state => state.sales.salesTypeList,
      branchList: state => state.branches.branchList,
      productList: state => state.products.productList,
      productListSelect: state => state.products.productListSelect,
      uomList: state => state.uom.uomList,
      userList: state => state.users.userAll,
      taxList: state => state.taxes.taxList,
      priceListGroup: state => state.priceLists.priceListGroup,
      salesTermConditionList: state => state.sales.salesTermConditionList,
      termDueList: state => state.termduedates.termDueList,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser,
      warehouseList: state => state.warehouses.warehouseList
    }),
    totalDetailSubtotal () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].subtotal * parseInt(array[i].qty))
      }
      return sum
    },
    totalDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDetailTax () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return sum
    },
    totalDetailDiscount () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
      }
      return sum
    },
    customerSalesList () {
      var array = this.order.sales
      var loop = []
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          var arrDetail = array[i].details
          if (arrDetail.length > 0) {
            for (let a = 0; a < arrDetail.length; a++) {
              var obj = {
                id: arrDetail[a].id,
                sale_no: array[i].sale_no,
                sale_date: array[i].sale_date,
                product_no: arrDetail[a].product_no,
                product: arrDetail[a].description,
                qty: arrDetail[a].qty,
                uom_id: arrDetail[a].uom_id
              }
              loop.push(obj)
            }
          }
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryOrder.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    getAttachment: function () {
      return this.order.attachments.filter(d => d.id !== null)
    },
    getOrderExpenseTerm: function () {
      return this.order.expenses.filter(d => d.type === 'term')
    },
    getOrderExpenseBiaya: function () {
      return this.order.expenses.filter(d => d.type !== 'term')
    },
    getTotalExpense: function () {
      // var manPower = this.order.expenses.find(d => d.description === 'Man Power')
      // var workDay = this.order.expenses.find(d => d.description === 'Working day')
      // console.log('working day')
      // console.log(workDay)
      // var array = this.order.expenses.filter(d => d.type === 'biaya').filter(d => d.description !== 'Transport')
      // console.log(array)
      var sum = 0
      // for (let i = 0; i < array.length; i++) {
      //   sum += (parseFloat(array[i].amount.replace(/\./g, '')) * parseFloat(manPower.amount)) * workDay.amount
      // }
      // var transport = this.order.expenses.find(d => d.type === 'biaya' && d.description === 'Transport')
      // if (transport) {
      //   sum = sum + parseFloat(transport.amount.replace(/\./g, ''))
      // }
      return sum
    },
    getTotalCost: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost.replace(/\./g, ''))
      }
      return sum.toString()
    },
    getTotalMargin: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += array[i].qty * array[i].margin
      }
      return sum.toString()
    },
    getGrossProfit: function () {
      var total = 0
      total = parseFloat(this.getTotal) - parseFloat(this.getTotalCost)
      return total
    },
    getGrossProfitPercentage: function () {
      var total = 0
      total = (this.getGrossProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getNetProfit: function () {
      var total = this.getGrossProfit - this.getTotalExpense
      return total
    },
    getNetProfitPercentage: function () {
      var total = 0
      total = (this.getNetProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getSubtotal: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (isNaN(array[i].total) === false) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    getSubtotal2: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    getTax: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var taxId = this.order.tax_id
      var taxAmount = 0
      var taxLis = this.taxList.find(d => d.id === taxId)
      if (taxLis) {
        if (taxLis.include === false) {
          taxAmount = (subtotal - discount) * (parseInt(taxLis.amount) / 100)
          return taxAmount.toString()
        } else {
          return '0'
        }
      } else {
        return '0'
      }
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getTotal () {
      var subtotal = this.getSubtotal2
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var subtotal2 = subtotal - discount
      var total = parseFloat(subtotal2) + parseFloat(this.order.tax)
      return total.toString()
    }
  },
  methods: {
    async getSpNo () {
      var data = {
        project_name: this.order.project_name
      }
      await axios.post(saleOrderUrl + '/get-sp-no', data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.error.project_name = ''
        })
        .catch(error => {
          console.log(error.response)
          this.error.project_name = error.response.data.message
        })
    },
    decreaseDetail (index) {
      if (this.order.lock === false) {
        var detail = this.order.details[index]
        detail.qty = parseFloat(detail.qty) - 1
        this.calcRowPrice(index)
      }
    },
    increaseDetail (index) {
      if (this.order.lock === false) {
        var detail = this.order.details[index]
        detail.qty = parseFloat(detail.qty) + 1
        this.calcRowPrice(index)
      }
    },
    selectProductGrid (product) {
      var prd = this.productListSelect.find(d => d.product_no === product)
      this.order.details.push({
        order_no: null,
        order_date: null,
        branch_no: null,
        branch: null,
        product_no: product,
        product: prd ? prd.product_name : null,
        description: prd ? prd.product_name : null,
        qty: 1,
        qty_done: '0',
        serial_number: null,
        uom_id: null,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: '0',
          active: false,
          cost: '0',
          price: '0'
        }],
        price: '0',
        discount: 0,
        discount_percentage: '0',
        margin: 0,
        margin_percentage: 0,
        tax_id: null,
        tax: '0',
        subtotal: '0',
        total: '0',
        queue: null,
        state: null,
        cost: '0',
        cost_id: null
      })
      this.state = 'create'
    },
    async unlock () {
      var body = {
        id: this.order.id
      }
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Unlock it!'
      }).then((result) => {
        if (result.value) {
          axios.post(saleOrderUrl + '/unlock', body, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.order.order_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = (Math.round(remaining / (1000 * 3600 * 24)))
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.purchasing.purchasing_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.purchasing.purchasing_date = date1.toISOString()
      }
    },
    async validateDetailDuplicate () {
      window.scrollTo(0, 0)
      this.alert = []
      var array = this.order.details
      var result = []
      var resultProductNo = []
      var resultProductUom = []
      array.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var price = value.price.replace(/\./g, '')
          var key = value.product_no + price
          console.log(key)
          if (!res[key]) {
            res[key] = {
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            }
          } else {
            result.push({
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            })
          }
          // check uom null
          if (value.uom_id === null) {
            resultProductUom.push({
              id: value.id + 'uom',
              product_no: value.product_no
            })
          }
        } else {
          resultProductNo.push({
            id: res
          })
        }
        return res
      }, {})
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push({
            message: 'Duplicate Product & Price (<b>' + result[i].product_no + ' | ' + result[i].price + '</b>)'
          })
        }
      }
      if (resultProductUom.length > 0) {
        for (let z = 0; z < resultProductUom.length; z++) {
          this.alert.push({
            message: 'Uom cannot be null ' + resultProductUom[z].product_no
          })
        }
      }
      if (this.order.salesman_id === null) {
        this.alert.push({
          message: '<b>Salesman</b> harus diinput terlebih dahulu'
        })
      }
      if (this.order.customer_no === null) {
        this.alert.push({
          message: '<b>Customer</b> harus diinput terlebih dahulu'
        })
      }
      var detailLength = this.order.details.length
      var detailNull = this.order.details.filter(d => d.product_no === null)
      if (parseFloat(detailNull.length) === parseFloat(detailLength)) {
        this.alert.push({
          message: '<b>Product</b> harus diinput terlebih dahulu'
        })
      }
    },
    async requestEdit (value) {
      var sales = this.order.sales.filter(d => d.id !== null)
      var note = ''
      if (sales.length > 0) {
        // this.$swal('Validation', '<b>Order</b> sudah diproses penjualan, cek <b>Penjualan</b> terlebih dahulu', 'error')
        // return false
        note = '[already sales]'
      }
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.order.order_no,
        lock_note: value + ' ' + note,
        type: 'sales-order'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Order has been requested (' + this.order.order_no + ')', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestVoid (value) {
      var sales = this.order.sales.filter(d => d.id !== null)
      if (sales.length > 0) {
        this.$swal('Validation', '<b>Order</b> sudah diproses penjualan, cek <b>Penjualan</b> terlebih dahulu', 'error')
        return false
      }
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.order.order_no,
        lock_note: value,
        type: 'sales-order-void'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Order has been requested (' + this.order.order_no + ')', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async removeOrder () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete(saleOrderUrl + '/' + this.order.id, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async resetOrderDone () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        array[i].qty_done = 0
      }
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async syncOrderAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        await this.syncOrder(i, 'no reply')
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success sync order to sales', 'success')
    },
    async syncOrder (index, reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var detail = this.order.details[index]
      var obj = {
        product_no: detail.product_no,
        order_no: this.order.order_no,
        price: detail.price.replace(/\./g, ''),
        uom_id: detail.uom_id
      }
      console.log(obj)
      console.log(saleOrderUrl + '/sync-to-sales')
      await axios.post(saleOrderUrl + '/sync-to-sales', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          if (reply === 'reply') {
            this.$swal('Success', response.data.message, 'success')
          }
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    getSaleNo (sale) {
      var obj = {
        sale_no: sale
      }
      this.$store.dispatch('getSaleByNo', obj)
    },
    selectProductToSaleList (product) {
      if (this.searchQueryOrder === null || this.searchQueryOrder === '') {
        this.searchQueryOrder = product
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else if (this.searchQueryOrder === product) {
        if (this.searchQueryOrder !== product) {
          this.searchQueryOrder = ''
        } else {
          this.searchQueryOrder = ''
        }
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    async getCustomerOrder () {
      var obj = {
        customer_no: this.sales.customer_no
      }
      await axios.post(customerUrl + '/order', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async processSales (sales) {
      await axios.post(salesUrl, sales, { headers: getHeader() })
        .then(response => {
          this.$emit('backReload', this.order.id)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response.data)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    setSalesInvoice () {
      var array = this.order.details
      var loopDetail = []
      var obj = {}
      var warehouse = this.warehouseList.find(d => d.company_no === this.authUser.company_no)
      for (let i = 0; i < array.length; i++) {
        var qty = parseInt(array[i].qty) - parseInt(array[i].qty_done)
        obj = {
          sale_date: null,
          branch_no: array[i].branch_no,
          product_no: array[i].product_no,
          product_sku: null,
          description: array[i].description,
          qty: qty,
          serial_number: array[i].serial_number,
          uom_id: array[i].uom_id,
          uomList: array[i].uomList,
          price: array[i].price,
          tax_id: array[i].tax_id,
          tax: array[i].tax,
          discount: array[i].discount,
          total: array[i].total,
          queue: null,
          warehouse_no: warehouse ? warehouse.warehouse_no : null,
          internal_code: null,
          cost: array[i].cost,
          cost_id: array[i].cost_id,
          sec_serial_number: null,
          company_no: this.authUser.company_no
        }
        console.log(obj)
        loopDetail.push(obj)
      }
      this.dataSales = {
        sale_date: new Date().toISOString(),
        sale_due_date: null,
        type_id: 1,
        customer_no: this.order.customer_no,
        customer: this.order.customer,
        branch_no: this.order.branch_no,
        warehouse_no: null,
        subtotal: this.order.subtotal,
        tax_id: this.order.tax_id,
        taxes: this.order.taxes,
        tax: this.order.tax,
        discount: this.order.discount,
        total: this.order.total,
        delivery_cost: this.order.delivery_cost,
        deliver_no: this.order.deliver_no,
        salesman_id: this.order.salesman_id,
        price_id: this.order.price_id,
        order_no: this.order.order_no,
        company_no: this.authUser.company_no,
        status: 'order',
        details: loopDetail
      }
    },
    getTermCondition: function () {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      var obj = this.salesTermConditionList.find(d => d.term_no === this.order.term_no)
      var newDueDate = new Date(this.order.order_due_date)
      var month = monthNames[(newDueDate.getMonth() + 1)]
      var dueDate = newDueDate.getDate() + '/' + month + '/' + newDueDate.getFullYear()
      this.order.term_notes = obj.notes.replace('{date}', dueDate)
    },
    getProductList: function () {
      var date = new Date(this.order.order_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.order.price_id,
        branch: this.order.branch_no,
        warehouse: null,
        date: newDate
      }
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    selectTemplate: function (tmp) {
      console.log('select template')
      this.order.details = []
      var array = tmp.details
      var tax = this.taxList.find(d => d.id === this.order.tax_id)
      for (let i = 0; i < array.length; i++) {
        console.log(array[i].product_no)
        var value = this.productList.find(d => d.product_no === array[i].product_no)
        console.log(value)
        var dpp = value.price
        var totalTax = dpp * tax.amount / 100
        if (tax.include === false) {
          totalTax = dpp * tax.amount / 100
        } else {
          totalTax = 0
        }
        var obj = {
          order_no: null,
          branch_no: this.order.branch_no,
          product_no: value.product_no,
          description: value.product_name,
          qty: array[i].qty,
          serial_number: null,
          uom_id: value.uom_id,
          price: value.price,
          tax_id: null,
          tax: totalTax,
          discount: 0,
          total: value.price,
          state: 'create',
          uomList: value.uomList,
          cost: value.product_cost.toString(),
          cost_id: value.cost_id,
          margin: 0
        }
        this.order.details.push(obj)
      }
    },
    async createNewOrder () {
      await axios.post(saleOrderUrl + '/duplicate', this.order, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backReload', response.data.data.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async downloadAttachments (id, filename) {
      await axios({
        url: saleOrderUrl + '/attachment/' + id,
        method: 'GET',
        responseType: 'blob',
        headers: getHeader()
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    removeAttachments (id) {
      var attch = this.order.attachments.find(d => d.id === id)
      var index = this.order.attachments.findIndex(d => d.id === id)
      console.log(attch.url)
      if (attch.order_no === null) {
        this.order.attachments.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleOrderUrl + '/attachment/' + attch.url, { headers: getHeader() })
              .then(response => {
                this.order.attachments.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
    },
    async upload () {
      this.loading = true
      this.uploading = false
      const formData = new FormData()
      formData.append('file', this.file)
      if (this.order.order_no) {
        formData.append('order_no', this.order.order_no)
      }
      console.log(formData)
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      await axios.post(saleOrderUrl + '/attachment', formData, { headers: newObj })
        .then(response => {
          console.log(response.data.data)
          const data = response.data.data
          var newId = null
          if (data.id === null) {
            newId = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
          } else {
            newId = data.id
          }
          this.order.attachments.push({
            id: newId,
            order_no: data.order_no,
            filename: data.filename,
            url: data.url,
            extension: data.extension,
            real_path: data.real_path,
            size: data.size,
            mime_type: data.mime_type,
            upload_date: data.upload_date,
            queue: null
          })
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            'Failed to upload',
            'error'
          )
        })
      this.loading = false
      this.uploading = true
    },
    printSO: function () {
      window.open(sale2Url + '/print/' + this.order.id + '/so', '_blank')
    },
    async approveSales () {
      var obj = {
        id: this.order.id
      }
      await axios.post(saleOrderUrl + '/approve/', obj, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async dealSales () {
      var obj = {
        id: this.order.id
      }
      await axios.post(saleOrderUrl + '/dealing', obj, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Deal',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    setTax: function () {
      // var tax = this.taxList.find(d => d.id === this.order.tax_id)
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        this.calcRowPrice(i)
      }
    },
    setTaxTotal () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
      }
      return sum
    },
    calcRowPrice: function (index) {
      var qty = this.order.details[index].qty
      var amount = parseFloat(this.order.details[index].price.toString().replace(/\./g, ''))
      var discountPercentage = parseFloat(this.order.details[index].discount_percentage)
      var discount = amount * discountPercentage / 100
      console.log(discount)
      var tax = this.taxList.find(d => d.id === this.order.tax_id)
      var subtotal = amount - discount
      var dpp = 0
      var taxAmount = 0
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = subtotal - dpp
          } else {
            dpp = subtotal / 1.1
            taxAmount = subtotal - dpp
          }
        }
      }
      this.order.details[index].discount = discount.toString()
      this.order.details[index].subtotal = Math.round(dpp)
      this.order.details[index].tax = Math.round(taxAmount)
      this.order.details[index].total = (Math.round(dpp) + Math.round(taxAmount)) * qty

      this.order.discount = this.totalDetailDiscount
      this.order.subtotal = this.totalDetailSubtotal
      this.order.tax = this.totalDetailTax
      this.order.total = this.totalDetail
    },
    calcRow (index) {
      var detail = this.order.details[index]
      var priceRatio = detail.uomList.find(i => i.id === detail.uom_id)
      var price = 0
      console.log(priceRatio)
      if (priceRatio.ratio === '0') {
        price = priceRatio.price
        detail.price = price.toString()
      } else {
        price = priceRatio.price * priceRatio.ratio
        detail.price = price.toString()
      }
      this.calcRowPrice(index)
      // detail.total = parseFloat(detail.qty) * parseFloat(detail.price)
    },
    setIdDetail: function (id) {
      this.idDetail = id
      var payload = {
        date: this.order.sale_date
      }
      this.$store.dispatch('getProductWithTotal', payload)
      // this.getType()
    },
    getType: function () {
      var date = new Date(this.order.order_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.order.price_id,
        branch: this.order.branch_no,
        warehouse: null,
        date: newDate
      }
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    onBarcodeScanned (barcode) {
      var obj = {
        barcode: barcode
      }
      console.log(barcode)
      axios.post(productUrl + '/scan/barcode', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          const product = response.data.data
          var productDetail = this.order.details.find(d => d.product_no === product.product_no)
          if (productDetail) {
            productDetail.qty = parseInt(productDetail.qty) + 1
            productDetail.total = parseInt(productDetail.qty) * parseFloat(productDetail.price)
          } else {
            // const price = product.productGet.uomList.find(d => d.category_id === 3)
            var obj = {
              id: Math.floor(Math.random() * (99999999 - 66666666) + 66666666),
              product_no: product.product_no,
              product: product.productGet.product_name,
              description: product.productGet.product_description,
              qty: 1,
              uom_id: product.productGet.uom_id,
              price: product.price,
              discount: '0',
              total: product.price,
              state: null,
              uomList: product.productGet.uomList
            }
            this.order.details.push(obj)
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerListLite')
    },
    createCustomer: function (customer) {
      console.log(customer)
      this.order.customer_no = customer.customer_no
    },
    checkTax: function () {
      var cmp = this.companyList.find(d => d.company_no === this.order.company_no)
      this.order.tax_id = cmp.tax_id
      this.setTax()
    },
    detailClear: function () {
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        // array[i].edit = false
      }
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    },
    async updateSales () {
      await this.validateDetailDuplicate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Error', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {}
      var array = this.order.details
      var qtys = this.order.qtys
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null) {
          if (qtys.length > array.length) {
            console.log('update')
            for (let j = 0; j < qtys.length; j++) {
              if (array[i].product_no === qtys[j].product_no) {
                qtys[j].customer_no = this.order.customer_no
                qtys[j].product_no = array[i].product_no
                qtys[j].ref_no = this.order.order_no
                qtys[j].qty = array[i].qty
                qtys[j].uom_id = array[i].uom_id
                qtys[j].qty_date = this.order.order_date
                qtys[j].type = 'in'
                qtys[j].status = 'updated'
                qtys[j].company_no = this.order.company_no
              }
            }
          } else {
            console.log('create')
            obj = {
              customer_no: this.order.customer_no,
              product_no: array[i].product_no,
              ref_no: this.order.order_no,
              qty: array[i].qty,
              uom_id: array[i].uom_id,
              qty_date: this.order.order_date,
              type: 'in',
              status: 'created',
              company_no: this.order.company_no
            }
            this.order.qtys.push(obj)
          }
        }
      }
      await axios.put(saleOrderUrl + '/' + this.order.id, this.order, { headers: getHeader() })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async createSales () {
      await this.validateDetailDuplicate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Error', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      this.order.status = 'open'
      this.order.lock = false
      var obj = {}
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null) {
          obj = {
            customer_no: this.order.customer_no,
            product_no: array[i].product_no,
            ref_no: this.order.order_no,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            qty_date: this.order.order_date,
            type: 'in',
            status: 'created',
            company_no: this.order.company_no
          }
          this.order.qtys.push(obj)
        }
      }
      await axios.post(saleOrderUrl, this.order, { headers: getHeader() })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    validateDetail () {
      var array = this.order.details.filter(d => d.product_no !== null)
      var productNO = []
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].qty) <= 0) {
          productNO.push({
            product_no: array[i].product_no
          })
        }
        if (array[i].uom_id === null || array[i].uom_id === '') {
          productNO.push({
            product_no: array[i].product_no
          })
        }
      }
      return productNO
    },
    addNewLine: function () {
      // this.$store.dispatch('getProductList')
      // var newID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.order.details.push({
        order_no: null,
        order_date: null,
        branch_no: null,
        branch: null,
        product_no: null,
        product: null,
        description: null,
        qty: 1,
        qty_done: '0',
        serial_number: null,
        uom_id: null,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: '0',
          active: false,
          cost: '0',
          price: '0'
        }],
        price: '0',
        discount: 0,
        discount_percentage: '0',
        margin: 0,
        margin_percentage: 0,
        tax_id: null,
        tax: '0',
        subtotal: '0',
        total: '0',
        queue: null,
        state: null,
        cost: '0',
        cost_id: null
      })
      this.state = 'create'
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    editDetail: function (id) {
      // var p = this.sales.details.find(d => d.id === id)
      this.idDetail = id
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    async removeDetail (index) {
      if (this.order.lock === false) {
        var detail = this.order.details[index]
        console.log(detail)
        if (typeof detail.id === 'undefined') {
          this.order.details.splice(index, 1)
        } else {
          await this.$swal.fire({
            title: 'Are you sure Delete this?',
            text: "You won't be able to revert this!",
            icon: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.value) {
              axios.delete(saleOrderUrl + '/detail/' + detail.id, { headers: getHeader() })
                .then(response => {
                  console.log(response.data.message)
                  this.order.details.splice(index, 1)
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                  this.$swal('Error', error.response.data.message, 'error')
                  throw error
                })
            }
          })
        }
        await this.calcRowPrice(index)
      }
    },
    async selectProduct (value) {
      console.log('start select product')
      if (this.order.lock === false) {
        this.$Progress.start()
        this.loader.isLoading = true
        // if (dtl) {
        //   this.$swal('Error', 'Product already pick', 'error')
        //   this.$Progress.finish()
        //   this.loader.isLoading = false
        //   return false
        // }
        var body = {
          product_no: value.product_no
        }
        var uomList = []
        await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
          .then(response => {
            uomList = response.data.data
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        var data = {
          product_no: value.product_no,
          date: this.order.order_date
        }
        await axios.post(productUrl + '/latest-price', data, { headers: getHeader() })
          .then(response => {
            var product = response.data.data
            var tax = this.taxList.find(d => d.id === this.order.tax_id)
            console.log(tax)
            var amount = parseFloat(product.price)
            var subtotal = amount
            var dpp = 0
            var taxAmount
            if (tax.include === false) {
              taxAmount = subtotal * tax.amount / 100
              dpp = subtotal
            } else {
              if (tax.amount === '0') {
                taxAmount = 0
                dpp = subtotal
              } else {
                taxAmount = subtotal * (tax.amount / 100)
                dpp = subtotal - taxAmount
              }
            }
            var obj = {
              order_no: this.order.order_no,
              branch_no: this.order.branch_no,
              product_no: product.product_no,
              description: product.product_name,
              qty: 1,
              qty_done: 0,
              serial_number: null,
              uom_id: product.uom_id,
              price: product.price.toString(),
              tax_id: tax.id,
              tax: taxAmount,
              discount: 0,
              discount_percentage: 0,
              subtotal: dpp,
              total: product.price,
              state: 'create',
              uomList: uomList,
              cost: 0,
              cost_id: null,
              margin: 0,
              margin_percentage: 0
            }
            this.order.details.push(obj)
            this.setTax()
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
          })
      }
    },
    async selectCustomerList (customer) {
      var checkStatus = false
      if (customer.rating_id === 'bad') {
        await this.$swal.fire({
          title: 'Are you sure add this Bad customer?',
          text: null,
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#28A745',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, add customer!'
        }).then((result) => {
          if (result.value) {
            checkStatus = true
          } else {
            checkStatus = false
          }
        })
      } else {
        checkStatus = true
      }
      if (checkStatus === true) {
        this.order.customer_no = customer.customer_no
        this.order.customer = customer
        var data = {
          company_no: this.order.company_no,
          customer_no: customer.customer_no
        }
        await axios.post(saleOrderUrl + '/get-latest-order', data, { headers: getHeader() })
          .then(response => {
            var sales = response.data.data
            // this.order.salesman_id = sales.salesman_id
            this.order.term_due_id = sales.term_due_id
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      } else {
        this.order.term_due_id = null
        this.order.customer_no = null
        this.order.customer = []
      }
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
  .input-qty {
    text-align: center;
    width: 25px;
    margin: 0 10px 0 10px;
    padding: 3px;
  }
</style>
